import { useContext } from 'react';

import { QSetReviewTaskContext } from './qset-review-task-provider';

export function useQSetReviewTask() {
  const context = useContext(QSetReviewTaskContext);

  if (!context) {
    throw new Error('useQSetReviewTask must be used within a QSetReviewTaskContextProvider');
  }

  return context;
}
